export async function deleteSpaceGameQuestion({ id, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/deleteSpaceGameQuestion`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({ id }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to delete question");
  }
  return data;
}
